import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type SessionService from 'teacher-ui-client/services/session'
import type AssignmentsRoute from 'teacher-ui-client/assignments/route'
import type AssignmentsProductRoute from 'teacher-ui-client/assignments/product/route'
import type AssignmentsManageDataService from 'teacher-ui-client/services/assignments-admin/manage-data'
import type { SchoolClassOptionTypes } from 'teacher-ui-client/components/base/select/school-class/options'

interface Params extends Record<string, unknown> {
  pageNumber: number
  perPage: number
  sortDirection: string
  sortColumn: string
  selectedSchoolClassId: string | SchoolClassOptionTypes
}

export default class AssignmentsProductManageMyStudentsRoute extends Route {
  @service session!: SessionService

  @service('assignments-admin/manage-data') assignmentsManageData!: AssignmentsManageDataService

  queryParams = {
    pageNumber: {
      refreshModel: true,
      replace: true,
    },
    perPage: {
      refreshModel: true,
      replace: true,
    },
    sortColumn: {
      refreshModel: true,
      replace: true,
    },
    sortDirection: {
      refreshModel: true,
      replace: true,
    },
    selectedSchoolClassId: {
      refreshModel: true,
      replace: true,
    },
  }

  // If a school has over the 2000 current assignment limit, assignments will be missing from the student grouped view.
  // Setting the backend assignments api limit to fix a pagination bug which was hiding assignments
  assignmentLimit = 2000 // default is 30

  async model(params: Params) {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    const { schoolClasses, students } = (this.modelFor('assignments') as ModelFor<AssignmentsRoute>) ?? {
      schoolClasses: [],
      students: [],
    }
    const { assignmentProduct: product } = this.modelFor('assignments.product') as ModelFor<AssignmentsProductRoute>

    const mySchoolClasses = schoolClasses.filter((sc) =>
      sc.teachers.some((t) => t.id === this.session.currentTeacher.id),
    )

    const assignmentsData = await this.assignmentsManageData.forMyStudents({
      selectedSchoolClassId: params.selectedSchoolClassId,
      currentTeacherId: this.session.currentTeacher.id,
      limit: this.assignmentLimit,
      product,
      students,
    })

    return { ...assignmentsData, subscriptionType, mySchoolClasses, totalStudents: students }
  }
}
